import { useEffect, useState } from 'react'

export function useDynamicSlidesOffset(
  containerRef: React.RefObject<HTMLElement>,
  maxWidth = 1160
): number {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    if (!containerRef.current) return

    const container = containerRef.current

    const updateOffset = () => {
      const viewportWidth = window.innerWidth
      const containerWidth = Math.min(container.offsetWidth, maxWidth)
      const offsetRight =
        viewportWidth > containerWidth
          ? (viewportWidth - containerWidth) / 2
          : 0
      setOffset(offsetRight)
    }

    const resizeObserver = new ResizeObserver(updateOffset)
    resizeObserver.observe(container)

    window.addEventListener('resize', updateOffset)
    updateOffset()

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener('resize', updateOffset)
    }
  }, [containerRef, maxWidth])

  return offset
}
